//  ----------      START   IMPORT  BLOCK       ----------
//  Widgets
import { Container, Row, Col } from "react-bootstrap";
//  Config
import "./Footer.css";
//  ----------      END   IMPORT  BLOCK       ----------

function Footer({ columns, bottomText }) {
  return (
    <footer className="footer">
      <Container>
        <Row>
          {columns.map((col, idx) => {
            if (idx < 3) {
              // Regular text column
              return (
                <Col key={idx} md={3} className="footer-col">
                  <h5>{col.title}</h5>
                  <ul className="footer-links">
                    {col.links.map((link, linkIdx) => (
                      <li key={linkIdx}>
                        <a href={link.href}>{link.text}</a>
                      </li>
                    ))}
                  </ul>
                </Col>
              );
            } else {
              // Logo & socials column
              return (
                <Col key={idx} md={3} className="footer-col">
                  {col.logo && (
                    <img
                      src={col.logo}
                      alt="Logo"
                      className="footer-logo"
                    />
                  )}
                  {col.address && (
                    <div className="footer-address">{col.address}</div>
                  )}
                  {col.socials && col.socials.length > 0 && (
                    <div className="social-icons">
                      {col.socials.map((social, sIdx) => (
                        <a
                          key={sIdx}
                          href={social.href}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {social.icon}
                        </a>
                      ))}
                    </div>
                  )}
                </Col>
              );
            }
          })}
        </Row>

        {bottomText && (
          <div className="footer-bottom">{bottomText}</div>
        )}
      </Container>
    </footer>
  );
}

export default Footer;
